module.exports = __webpack_public_path__ + "static/img/brees-2006-slide-7.78f071a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-slide-7.jpg
// module id = f3mo
// module chunks = 1